export const IFrameMock = {
  uid: "4c0b4e2e-07d0-4924-b1d2-63da36ca246c",
  componentName: "iFrame",
  dataSource: "{33338258-3FA2-4B59-8224-DDB689AC5FBE}",
  params: {
  },
  fields: {
    Link: {
      value: {
        href: "",
        linktype: "external",
        url: ""
      }
    }
  }
}
